import React from 'react';
import { useMeetingRequests } from '../../../../../../data/hooks/meeting/useMeetingRequests';
import CommonTabContent from '../CommonTabContent';

function RequestedMeetings(props) {
    const { eventId } = props,
        meetings = useMeetingRequests(eventId);

    return <CommonTabContent eventId={eventId} meetings={meetings} />;
}

export default RequestedMeetings;
